import { proxy } from "valtio";
import { SftpSettings } from "@models/SftpSettings.model";

interface OrganizationSftpState {
  organizationId: number | null;
  settings: SftpSettings | null;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const organizationSftpStore = proxy<OrganizationSftpState>({
  organizationId: null,
  settings: null,
  isLoading: false,
  isSaving: false,
  error: null,
});

export function resetOrganizationSftpStore() {
  organizationSftpStore.organizationId = null;
  organizationSftpStore.settings = null;
  organizationSftpStore.isLoading = false;
  organizationSftpStore.isSaving = false;
  organizationSftpStore.error = null;
}
